/* window.MI_CONFIG = {}; */
/* window.CHECKOUT_APP = {}; */
(function(){
'use strict';
var root=document.querySelector('[data-section-id]');if(!root)return;
var cd=root.querySelector('[data-countdown]');
if(cd){
var KEY='migrastil-cream_cd_end';
var end=parseInt(localStorage.getItem(KEY)||'0',10);
var now=Date.now();
if(!end||end<now){end=now+3*3600*1000;localStorage.setItem(KEY,end);}
var h=cd.querySelector('[data-h]'),m=cd.querySelector('[data-m]'),s=cd.querySelector('[data-s]');
function pad(n){return n<10?'0'+n:''+n;}
function tick(){
var d=Math.max(0,end-Date.now());
var H=Math.floor(d/3600000),M=Math.floor(d%3600000/60000),S=Math.floor(d%60000/1000);
h.textContent=pad(H);m.textContent=pad(M);s.textContent=pad(S);
if(d<=0){localStorage.removeItem(KEY);end=Date.now()+3*3600*1000;localStorage.setItem(KEY,end);}
}
tick();setInterval(tick,1000);
}
var io=new IntersectionObserver(function(es){
es.forEach(function(e){
if(!e.isIntersecting)return;
var v=e.target;
if(v.dataset.src){v.src=v.dataset.src;v.load&&v.load();}
io.unobserve(v);
});
},{rootMargin:'200px'});
root.querySelectorAll('video[data-src]').forEach(function(v){io.observe(v);});
})();